<template>
  <v-text-field
    :label="label"
    v-model="keyword"
    v-on:keyup.enter="$emit('input', keyword.trim())"
    :clearable="!unclearable"
    :hint="$t('Search.keywordSearchHint')"
    @click:clear="
      keyword = '';
      $emit('input', '');
    "
  ></v-text-field>
</template>

<script>
export default {
  name: "SearcherKeyword",

  props: { 
    value: String, 
    label: String,
    unclearable: Boolean,
  },

  components: {},

  data: () => ({
    keyword: "",
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
          this.keyword = this.value;
      },
    },
    keyword: {
      handler() {
        this.$emit("text", this.keyword);
      },
    },
  },

  methods: {
    clear() {
      this.keyword = "";
      this.$emit("input", "");
    },
  },
};
</script>
